export const setGeoCache = ({ address, geoObject, geoCache }) => {
  geoCache[address] = geoObject;
};

export const getGeoCache = (address, geoCache) => {
  return geoCache[address] || null;
};
